<template>
    <iframe
        :src="url"
        frameborder="0"
        :style="cssProps"
    ></iframe>
</template>

<script>
    export default {
        props: {
            url: {
                type: String,
                required: false
            },
            width: {
                type: String,
                default: '100%'
            },
            height: {
                type: String,
                default: '60vh'
            }
        },
        computed: {
            cssProps() {
                return {
                    'width': this.width,
                    'height': this.height
                }
            }
        }
    }
</script>
